import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";

export class Note extends FBase {

    categoryName: string = null;
    courseName: string = null;
	chapterName: string = null;
    content: string = null;
	cleanedContent: string = null;
    courseImage: string = null;
	courseId: string = null;
	categoryNameLowercase: string = null;
    courseNameLowercase: string = null;
	chapterNameLowercase: string = null;

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}
}
export namespace Note {

	export const PATH = 'notes';
}
